import { render } from "./NewCustomerReturnReason.vue?vue&type=template&id=659713e8"
import script from "./NewCustomerReturnReason.vue?vue&type=script&lang=js"
export * from "./NewCustomerReturnReason.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__